import { render, staticRenderFns } from "./VideoConnecting.vue?vue&type=template&id=bb0652c4&"
import script from "./VideoConnecting.vue?vue&type=script&lang=js&"
export * from "./VideoConnecting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports